import { State as DataState, toDataSourceRequestString } from '@progress/kendo-data-query';

export function buildSearchQueryString(dataState: DataState, query: string | undefined | null): string {
    const querySegments: Array<string> = [];

    if (query) {
        querySegments.push(`query=${encodeURIComponent(query)}`);
    }

    const kendoQueryStr = toDataSourceRequestString(dataState);
    if (kendoQueryStr) {
        querySegments.push(kendoQueryStr);
    }

    return querySegments.join('&');
}
